import { useEffect, useRef } from "react";

import type { Emptyable, FormType } from "@simplyk/common";

import { pushGtmFormView } from "@/common/helpers/gtm";

type UseGtmFormViewParams = {
  formId: Emptyable<string>;
  formPath: Emptyable<string>;
  formType: Emptyable<FormType>;
  organizationId: Emptyable<string>;
};

export const useGtmFormView = ({ formId, formPath, formType, organizationId }: UseGtmFormViewParams): void => {
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (hasFiredRef.current) {
      return;
    }

    if (typeof window === "undefined") {
      return;
    }

    if ((formId || formPath) && organizationId) {
      pushGtmFormView({
        formId,
        formPath,
        organizationId,
        formType,
      });
      hasFiredRef.current = true;
    }
  }, [formId, formPath, formType, organizationId]);
};
